import { useErrorHandler } from '@/hooks/useErrorHandler';

export function MessageDisplay() {
  const [errorState, errorActions] = useErrorHandler();

  if (errorState.errors.length === 0 && errorState.successMessages.length === 0) {
    return null;
  }

  return (
    <div className="message-display">
      {/* Error Messages */}
      {errorState.errors.map((error, index) => (
        <div key={`error-${index}`} className="error-message">
          <span className="message-text">{error}</span>
          <button
            onClick={errorActions.clearErrors}
            className="message-close"
            aria-label="Close error message"
          >
            ×
          </button>
        </div>
      ))}

      {/* Success Messages */}
      {errorState.successMessages.map((message, index) => (
        <div key={`success-${index}`} className="success-message">
          <span className="message-text">{message}</span>
          <button
            onClick={errorActions.clearSuccess}
            className="message-close"
            aria-label="Close success message"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}